import { mapGetters } from 'vuex'
import { currencyTransformer } from '@/lib/mask'

import { finCalcPotencialInfos } from '@/pages/buying-power/buying-power.tracker'
import ozBuyingPowerValue from './oz-buying-power-value/oz-buying-power-value.vue'
import ozBuyingPowerAlert from '../oz-buying-power-alert/oz-buying-power-alert.vue'
import { finCalcSearchClick } from './oz-buying-power-calculator-button.tracker'

export default {
  name: 'oz-buying-power-result',

  components: {
    ozBuyingPowerValue,
    ozBuyingPowerAlert,
  },
  computed: {
    ...mapGetters({
      buyingPowerData: 'buyingPower/getBuyingPowerData',
    }),
    hasBuyingPowerData () {
      return !!this.buyingPowerData
    },
    buyingPowervalueMasked () {
      return currencyTransformer(this.buyingPowerData?.buyingPowerValue)
    },
    downPaymentMasked () {
      return this.getMaskedCurrency(this.buyingPowerData?.downPayment)
    },
    downPaymentMinMasked () {
      return this.getMaskedCurrency(this.buyingPowerData?.downPaymentMin)
    },
    financialValueMasked () {
      return this.getMaskedCurrency(this.buyingPowerData?.financialValue)
    },
    itbiMasked () {
      return this.getMaskedCurrency(this.buyingPowerData?.itbi)
    },
    downPaymentPercentage () {
      return this.calculatetWidth(this.buyingPowerData?.downPayment)
    },
    financialValuePercentage () {
      return this.calculatetWidth(this.buyingPowerData?.financialValue)
    },
    itbiPercentage () {
      return this.calculatetWidth(this.buyingPowerData?.itbi)
    },
    showDownPaymentMinAlert () {
      return this.buyingPowerData?.downPayment < this.buyingPowerData?.downPaymentMin
    },
  },

  methods: {
    trackInfo () {
      finCalcPotencialInfos()
    },
    getMaskedCurrency (valor) {
      if (!this.hasBuyingPowerData) return null
      return currencyTransformer(valor)
    },
    calculatePercentage (value) {
      return (value / this.buyingPowerData.buyingPowerValue) * 100
    },
    calculatetWidth (value) {
      let percentage
      if (this.hasBuyingPowerData) {
        percentage = this.calculatePercentage(value)
      } else {
        percentage = '33'
      }
      return `${percentage}%`
    },
    redirect () {
      const urlParams = Object.fromEntries(new URLSearchParams(window.location.search))

      finCalcSearchClick()

      const params = new URLSearchParams({
        ...urlParams,
        pagina: 1,
        itl_id: 1000039,
        transacao: 'Venda',
        precoMinimo: 0,
        precoMaximo: this.buyingPowerData.buyingPowerValue,
        itl_name: 'zapimoveis_financiamento-calc-potencial_botao-cta_buscar-imoveis_to_zapimoveis_resultado-pesquisa-compra',
      }).toString()

      window.open(`https://www.zapimoveis.com.br/venda/?${params}`, '_blank')
    },
  },
}
